import styled from "styled-components";
import {fontSize} from "../../../../themes";

export const StampWrapper = styled.div`
  position: relative;
  width: 154px;
  height: 137px;
  > img {
    position: absolute;
    top: 0;
    left: 0;
  }
  > span {
    position: absolute;
    left: 0;
    width: 100%;
    top: 82px;
    height: 39px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-style: normal;
    font-weight: 700;
    ${fontSize(13)}
    line-height: 127.5%;
    text-transform: uppercase;
    color: #FFFFFF;
    padding-left: 4px;
    padding-right: 4px;
    box-sizing: border-box;
    word-wrap: anywhere;
  }
`;
